import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../Button';
import {
  List,
  ListItem,
} from '@mui/material';
import {
  BodyMenuMobile,
  ContBodyMenuMobile,
  ContFooterMenuMobile,
  ContItemsMenuMobile,
  ContItemsMenuMobileBtn,
  ContMenuMobile,
  ListaServiciosMobile,
  ImgMenu,
  ItemMenuMobile,
  ExpandIco,
  ContItemMenuMobileServices,
  ContItemMenuMobileLenguagess,
  ItemMenuMobileServices,
  ContGLobe,
} from './MenuMobile.styles';
import IcoExpand from '../../assets/images/ico-expand.svg';
import icoMenu from '../../assets/images/ico-hamburger.svg';
import icoClose from '../../assets/images/ico-close.svg';
import icoOnboarding from '../../assets/images/iconns-menu/ico-onboarding.svg';
import IcoAnalisis from '../../assets/images/Icons-datatoggle/icon-analisis.webp';
import IcoDispersion from '../../assets/images/Icons-datatoggle/icon-dispersion.webp';
import IcoMoney from '../../assets/images/Icons-datatoggle/ico-money.webp';
import IcoScoring from '../../assets/images/Icons-datatoggle/ico-scoring.webp';
import IcoSecurity from '../../assets/images/Icons-datatoggle/ico-security.webp';
import IcoCC from '../../assets/images/Icons-datatoggle/ico-creditcard.webp';
import IcoNoti from '../../assets/images/Icons-datatoggle/ico-noti.webp';
import IcoPayServces from '../../assets/images/Icons-datatoggle/ico-payservices.webp';
import IcoAutom from '../../assets/images/Icons-datatoggle/icon-autom.webp';
import GlobeIcon from '../../assets/images/globe-icon.png';

const MenuMobile = () => {
  const { i18n, t } = useTranslation();
  const [onShowMenu, setOnShowMenu] = useState(false);
  const [serviciosOpen, toggleServiciosOpen] = useState(false);
  const [lenguages, setLenguages] = useState(false);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [borderBottomPad, setBorderBottomPad] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  const isEnglish = i18n.language === 'en';
  const currentYear = new Date().getFullYear();

  const routes = {
    home: isEnglish ? '/en' : '/',
    about: isEnglish ? '/en/about-us' : '/nosotros',
    benefits: isEnglish ? '/en/benefits' : '/beneficios',
    core: isEnglish ? '/en/banking-core' : '/core-bancario',
    useCases: isEnglish ? '/en/credit-use-case' : '/caso-de-uso-credito',
    contact: isEnglish ? '/en/contact' : '/contacto',
    services: {
      onboarding: isEnglish ? '/en/onboarding' : '/onboarding',
      creditAnalysis: isEnglish ? '/en/credit-analysis' : '/analisis-crediticio',
      dispersion: isEnglish ? '/en/payment-dispersion' : '/dispersion-pagos',
      collections: isEnglish ? '/en/collections' : '/cobranza',
      scoring: isEnglish ? '/en/alternative-scoring' : '/score-alternativo',
      pld: isEnglish ? '/en/anti-money-laundering' : '/pld',
      cardIssuance: isEnglish ? '/en/card-issuance' : '/emision-tarjetas',
      notifications: isEnglish ? '/en/notifications' : '/notificaciones',
      payServices: isEnglish ? '/en/pay-services' : '/pago-servicios',
      deviceLock: isEnglish ? '/en/device-lock' : '/bloqueo-dispositivos',
    },
  };

  const onShowMenuMobile = () => {
    setOnShowMenu(!onShowMenu);
  };

  const toggleContent = () => {
    toggleServiciosOpen(!serviciosOpen);
    setIsContentVisible(!isContentVisible);
    setBorderBottomPad(!borderBottomPad);
  };

  const handleChangeLanguage = (newLanguage) => {
    i18n.changeLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
    setOnShowMenu(false);
  };

  return (
    <ContMenuMobile id={'ContMenuMobile'}>
      <ImgMenu
        src={onShowMenu ? icoClose : icoMenu}
        alt="img-menu"
        onClick={onShowMenuMobile}
      />
      {onShowMenu ? (
        <ContBodyMenuMobile id={'ContBodyMenuMobile'}>
          <BodyMenuMobile>
            <ContItemsMenuMobile>
              <Link to={routes.home} style={{ textDecoration: 'none' }}>
                <ItemMenuMobile>Home</ItemMenuMobile>
              </Link>
              <Link to={routes.about} style={{ textDecoration: 'none' }}>
                <ItemMenuMobile>{t('Nosotros')}</ItemMenuMobile>
              </Link>
              <Link to={routes.benefits} style={{ textDecoration: 'none' }}>
                <ItemMenuMobile>{t('Beneficios')}</ItemMenuMobile>
              </Link>
              <ItemMenuMobile onClick={() => toggleContent()} borderBottom={borderBottomPad}>
                {t('Servicios')}
                <ExpandIco
                  src={IcoExpand}
                  alt={isContentVisible ? 'Expandir' : 'Contraer'}
                  isContentVisible={!isContentVisible}
                />
              </ItemMenuMobile>
              {serviciosOpen && (
                <ListaServiciosMobile>
                  <Link to={routes.services.onboarding} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={icoOnboarding} alt="Onboarding" /> {t('Onboarding Digital')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.creditAnalysis} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoAnalisis} alt="Análisis" />{t('Análisis Crediticio')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.dispersion} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoDispersion} alt="Dispersión" />{t('Dispersión')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.collections} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoMoney} alt="Cobranza" />{t('Cobranza')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.scoring} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoScoring} alt="Score alternativo" /> {t('Score alternativo')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.pld} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoSecurity} alt="PLD" /> PLD
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.cardIssuance} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoCC} alt="Emisión" />{t('Emisión de tarjetas')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.notifications} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoNoti} alt="Campaña" />{t('Campaña de notificaciones')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.payServices} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoPayServces} alt="Pago" />{t('Pago de servicios')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.deviceLock} style={{ textDecoration: 'none' }}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices borderBottom={true}>
                        <img src={IcoAutom} alt="Candado" />{t('Candado de Smartphones')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                </ListaServiciosMobile>
              )}

              <Link to={routes.core} style={{ textDecoration: 'none' }}>
                <ItemMenuMobile>{t('Core Bancario')}</ItemMenuMobile>
              </Link>
              <Link to={routes.useCases} style={{ textDecoration: 'none' }}>
                <ItemMenuMobile>{t('Casos de uso')}</ItemMenuMobile>
              </Link>

              <a href="https://blog.dynamicore.io/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <ItemMenuMobile>Blog</ItemMenuMobile>
              </a>

              <ItemMenuMobile onClick={() => setLenguages(!lenguages)} borderBottom={borderBottomPad}>
                <ContGLobe style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img src={GlobeIcon} alt={'Globe icon'} width={30} />
                  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{currentLanguage === 'es' ? 'ES' : 'EN'}</span>
                </ContGLobe>
                <ExpandIco
                  src={IcoExpand}
                  alt={lenguages ? 'Expandir' : 'Contraer'}
                  isContentVisible={!lenguages}
                  style={{ position: 'relative', top: '-4px' }}
                />
              </ItemMenuMobile>
              {lenguages && (
                <ListaServiciosMobile>
                  <List disablePadding>
                    <ContItemMenuMobileLenguagess>
                      <ListItem onClick={() => handleChangeLanguage('en')} style={{ cursor: 'pointer' }}>
                        <ItemMenuMobileServices>
                          English
                        </ItemMenuMobileServices>
                      </ListItem>

                      <ListItem onClick={() => handleChangeLanguage('es')} style={{ cursor: 'pointer' }}>
                        <ItemMenuMobileServices>
                          Español
                        </ItemMenuMobileServices>
                      </ListItem>
                    </ContItemMenuMobileLenguagess>
                  </List>
                </ListaServiciosMobile>
              )}

              <ContItemsMenuMobileBtn>
                <Button
                  text={'Contáctanos'}
                  type={'/'}
                  linkTo={routes.contact}
                  withIcon={true}
                  target={'_self'}
                  theme={'secondary'}
                  size={'b'}
                />
              </ContItemsMenuMobileBtn>
            </ContItemsMenuMobile>
            <ContFooterMenuMobile>
              <div>{currentYear} Dynamicore©</div>
              <div>{t('Todos los derechos reservados')}</div>
            </ContFooterMenuMobile>
          </BodyMenuMobile>
        </ContBodyMenuMobile>
      ) : null}
    </ContMenuMobile>
  );
};

export default MenuMobile;
